import React, { useRef, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Loader from "./../../components/Loader/Loader";
import HeaderOne from "../../components/Header/HeaderOne";
import ArchitectureSlider from "../../components/Hero/ArchitectureSlider";
import MktRptAccordion from "../../components/Accordions/MktRptAccordion";
import AboutArchitecture from "../../components/AboutUs/AboutArchitecture";
// import FunFactsArchitecture from "../../components/FunFacts/FunFactsArchitecture";
import Numbers from "../../components/FunFacts/Numbers";
import ServicesArchitecture from "../../components/OurServices/ServicesArchitecture";
import Gallery from "../../components/Gallery/Gallery";
import ContactArchitecture from "../../components/ContactUs/ContactArchitecture";
import FooterOne from "../../components/Footer/FooterOne";


const Architecture = () => {
  const home = useRef();
  const about = useRef();
  const sales = useRef();
  const service = useRef();
  const agents = useRef();
  const rentals = useRef();
  const contact = useRef();

  const scrollToSection = (e, content) => {
    e.preventDefault();
    switch (content) {
      case "home":
        home.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "about":
        about.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "sales":
        sales.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "service":
        service.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "agents":
        agents.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "rentals":
        rentals.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "contact":
        contact.current.scrollIntoView({ behavior: "smooth" });
        break;
      default:
    }
  };

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <Loader>
      <HeaderOne scrollToSection={scrollToSection} />

      <MktRptAccordion type="color" classAppend="mt-120" />
      <ArchitectureSlider ref={home} />
      <AboutArchitecture ref={about} classAppend="mt-50" />

      {/* <FunFactsArchitecture
        title={new Date().getFullYear()}
        tagline="By The Numbers"
        paragraph1="Unsurprisingly, the rich got richer in 2024: The trophy market saw 278 deals at $10 million and above, 38 more than 2023. In trophy sales, 2024 ranked as the 2nd best year since this report was launched in 2006. The top year was 2021---the pandemic rebound year---when 400 trophy properties were sold."
        paragraph2={`Here is how ${new Date().getFullYear()} is shaping up so far`}
        paragraph3={`FOR PROPERTIES $4 MILLION DOLLARS AND ABOVE`}  paragraph4={<div dangerouslySetInnerHTML={{ __html: 'Data sourced from The Olshan Realty <a class="underline" href="/market-report">Luxury Market Report</a>.' }} />}
      /> */}
            <Numbers
        title={new Date().getFullYear()}
        tagline="By The Numbers"
        paragraph1="Unsurprisingly, the rich got richer in 2024: The trophy market saw 278 deals at $10 million and above, 38 more than 2023. In trophy sales, 2024 ranked as the 2nd best year since this report was launched in 2006. The top year was 2021---the pandemic rebound year---when 400 trophy properties were sold."
        paragraph2={`Here is how ${new Date().getFullYear()} is shaping up so far`}
        paragraph3={`FOR PROPERTIES $4 MILLION DOLLARS AND ABOVE`}  paragraph4={<div dangerouslySetInnerHTML={{ __html: 'Data sourced from The Olshan Realty <a class="underline" href="/market-report">Luxury Market Report</a>.' }} />}
        apiUrl={`${process.env.REACT_APP_API_BASE_URL}?op=numbers`}
      />


      <ServicesArchitecture
        title="OUR SERVICES"
        tagline="What We Do"
        ref={service}
      />

      <Gallery
        title="MORE FEATURED PROPERTIES"
        tagline="Currently ON MARKET"
        classAppend="mt-150"
        ref={sales}
      />

      <ContactArchitecture
        title="CONTACT OLSHAN"
        tagline="Connect to Your New Home"
        classAppend="mt-50"
        ref={contact}
      />
      <FooterOne />
    </Loader>
  );
};

export default Architecture;
